import { z } from "zod";
import { CreateOrderProductFormValues } from "../Product";
import OrderTypeEnum from "@/constants/enums/OrderTypeEnum";

const propertyFieldSchema = z
  .object({
    selectedValueId: z.string().nullable().optional(),
    config: z
      .object({
        required: z.boolean(),
      })
      .passthrough(),
  })
  .passthrough();

export const createProductValidationSchema = (
  orderType: number
): z.ZodType<Omit<CreateOrderProductFormValues, "properties">> =>
  z
    .object({
      price: z.string().nonempty({ message: "priceRequired" }),
      currency: z.string().nonempty({ message: "currencyRequired" }),
      unit: z.string().nonempty({ message: "unitRequired" }),
      minMaxPrice: z.string().optional(),
      priceAdjustPercentage: z.string().optional(),
      amount: z.string().nonempty({ message: "amountRequired" }),
      amountDeviation: z.string().optional(),
      minimumAmount: z.string().optional(),
      selectedSalesItemId: z.string().nonempty({ message: "required" }),
      properties: z
        .array(propertyFieldSchema)
        .nullable()
        .superRefine((items, ctx) => {
          if (!items) return;

          items.forEach((item, index) => {
            if (item.config.required && !item.selectedValueId) {
              ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: [index, "selectedValueId"],
                message: "required",
              });
            }
          });
        }),
    })
    .superRefine((data, ctx) => {
      if (!data.minMaxPrice || !data.price) return;

      const price = parseFloat(data.price);
      const minMaxPrice = parseFloat(data.minMaxPrice);

      if (isNaN(price) || isNaN(minMaxPrice)) return;

      if (orderType === OrderTypeEnum.BUY && minMaxPrice < price) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["minMaxPrice"],
          message: "maxPriceTooLow",
        });
      }

      if (orderType === OrderTypeEnum.SELL && minMaxPrice > price) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["minMaxPrice"],
          message: "minPriceTooHigh",
        });
      }
    });
